import { graphql } from '../../__generated__';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const COST_BREAK_DOWN = graphql(`
  query CostBreakDown($unitPrice: Float, $quantity: Float) {
    costBreakDown(unitPrice: $unitPrice, quantity: $quantity) {
      unitPrice
      quantity
      totalPrice
      transactionFee
      vatFee
      validReward
    }
  }
`);
